<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "MY_DOCS.TITLE" | translate }}</div>
</mat-toolbar>

<div class="content">
    <div
        fxLayout="row"
        *ngFor="let document of (user$ | async)?.documents; let i = index"
        (click)="download(document.url, document.name)"
    >
        <div class="listItem">
            <mat-icon class="img-curso-custom"> {{ document.name | filetype }}</mat-icon>

            <div class="media-body">
                <span class="title">
                    {{ document.name }}
                </span>
            </div>
        </div>

        <ng-container *ngIf="isLoading$ | async">
            <ghost-data *ngFor="let ghost of [1, 2, 3]" [show]="true" [opacity]="100 / ghost">
                <div class="listItem">
                    <div class="img-curso-custom">
                        <div class="loader"></div>
                    </div>

                    <div class="media-body">
                        <span class="title"> loading... </span>
                        <div class="instructor">loading...</div>
                    </div>
                </div>
            </ghost-data>
        </ng-container>

        <div class="action" *ngIf="!(isLoading$ | async) && (user$ | async)?.documents?.length <= 0">
            <span class="action-description">>{{ "MY_DOCS.NO_DATA" | translate }}</span>
            <span class="material-icons icon"> sentiment_satisfied_alt </span>
        </div>
    </div>
</div>
